/* eslint-disable no-restricted-syntax */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-empty */
/* eslint-disable eqeqeq */
/* eslint-disable no-shadow */
/* eslint-disable react/destructuring-assignment */
import {
  CrownTwoTone,
  DownOutlined,
  FlagTwoTone,
  FunnelPlotTwoTone,
  MailTwoTone,
  MessageTwoTone,
} from "@ant-design/icons";
import {
  Avatar,
  Button,
  Card,
  Col,
  DatePicker,
  Dropdown,
  List,
  Menu,
  message,
  Modal,
  notification,
  Radio,
  Row,
  Space,
  Spin,
  Tooltip,
} from "antd";
import dayjs from "dayjs";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Emoji from "react-emoji-render";
import { useNavigate } from "react-router-dom";

import { getAtRiskUsersDashboard } from "../../lib/queries";
import { getSupaClient } from "../../lib/supabase";
import RenderPieChart from "../Charts/RenderPieChart";
import { useEndTime, useStartTime } from "../DateContext/DateContext";
import EngagementCard from "../EngagementCard/EngagementCard";
import TopPosts from "../InsightsPage/TopPosts";
import UserListItem from "../UserListItem/UserListItem";

const { RangePicker } = DatePicker;

const defaultTimeFormat = "YYYY-MM-DDTHH:mm:ssZ";
const dateFormat = "MM/DD/YY";

const Overall = (props) => {
  const supabase = getSupaClient();
  const teamId = localStorage.getItem("team-id");
  const [loading, setLoading] = useState(true);
  const { startTime, setStartTime } = useStartTime();
  const { endTime, setEndTime } = useEndTime();
  const [popularPosts, setPopularPosts] = useState([]);
  const [powerUsers, setPowerUsers] = useState([]);
  const [messageType, setMessageType] = useState([]);
  const [activeChannels, setActiveChannels] = useState([]);
  const [inActiveChannels, setInActiveChannels] = useState([]);
  const [activeChannelRadio, setActiveChannelRadio] = useState(true);
  const [selectedMessages, setSelectedMessages] = useState([]);
  const [isPopularModalVisible, setPopularModalVisible] = useState(false);
  const [weeklyMessageCount, setWeeklyMessageCount] = useState([]);
  const [excludedChannels, setExcludedChannels] = useState([]);
  const [loadingActiveMember, setLoadingActiveMember] = useState(false);
  const [loadingConversation, setLoadingConversation] = useState(false);
  const [loadingChannels, setLoadingChannels] = useState(false);

  const engagementMetricsDefault = {
    currentActive: "-",
    previousActive: "-",
    currentMessage: "-",
    previousMessage: "-",
    loading: true,
  };
  const communityTaskDefault = [
    {
      name: "Unresponded messages (loading)",
      link: "/messages",
      emoji: <MessageTwoTone />,
    },
    {
      name: "Moderation queue (loading)",
      link: "/moderation",
      emoji: <FlagTwoTone />,
    },
    {
      name: "At risk members (loading)",
      link: "/users",
      emoji: <FunnelPlotTwoTone />,
    },
    {
      name: "Newly joined members (loading)",
      link: "/users",
      emoji: <CrownTwoTone />,
    },
    {
      name: "Send DMs",
      link: "/messages",
      emoji: <MailTwoTone />,
    },
  ];
  const [engagementMetrics, setEngagementMetrics] = useState(
    engagementMetricsDefault
  );
  const [communityTasks, setCommunityTasks] = useState(communityTaskDefault);
  // let params = props
  const navigate = useNavigate();

  window.moment = moment;

  const disabledDate = (current) => {
    // Can not select days before today and today
    return current && current > moment().endOf("day");
  };

  const loadExcludedChannels = async () => {
    const excludeChannel = await supabase
      .from("teams")
      .select("settings_exclude_channels")
      .match({ slack_id: teamId });
    if (
      excludeChannel.data &&
      excludeChannel.data[0] &&
      excludeChannel.data[0].settings_exclude_channels
    ) {
      return excludeChannel.data[0].settings_exclude_channels;
    }
    return null;
  };

  /**
   * Load data from custom_at_risk_users table
   */
  const loadAtRiskDef = async () => {
    const { data, error } = await supabase
      .from("custom_at_risk_users")
      .select("*")
      .eq("team", teamId);
    if (data.length > 0) {
      return data[0];
    }
    if (error) {
      console.log("Error", error);
      return null;
    }
    return null;
  };

  const prepareNoReplyCountBase = async (
    startTime,
    endDate,
    excludeChannels
  ) => {
    const base = supabase
      .from("parent_msgs")
      .select("slack_id, slack_users!slack_user!inner(*)", {
        count: "exact",
      })
      .filter("team", "eq", teamId)
      .filter("reply_count", "eq", 0)
      .or("to_reply_status.eq.assigned,to_reply_status.is.null")
      .filter("slack_users.is_admin", "neq", true)
      .filter("is_bot", "neq", true);
    if (excludeChannels) {
      excludeChannels.forEach((item) => {
        base.filter("channel", "neq", item);
      });
    }

    base
      .gte("formatted_ts", startTime)
      .lte("formatted_ts", endDate)
      .order("ts", { ascending: false });
    return base;
  };

  const loadTasks = async (
    startTime,
    endTime,
    excludeChannels,
    customAtRisk
  ) => {
    setCommunityTasks(communityTaskDefault);
    const endDate = dayjs(endTime).add(1, "day").format(dateFormat);
    const noReplyBase = await prepareNoReplyCountBase(
      startTime,
      endDate,
      excludeChannels
    );

    const [noreply, moderation, atRisk, newUsers] = await Promise.all([
      // no replies
      noReplyBase,
      // moderation
      supabase
        .from("spam_msgs")
        .select("slack_id", { count: "exact" })
        .eq("team", teamId)
        .filter("status", "is", null)
        .gte("formatted_ts", startTime)
        .lte("formatted_ts", endDate),
      // at risk users
      getAtRiskUsersDashboard(teamId, customAtRisk),
      // new users
      supabase
        .from("slack_users")
        .select("slack_id")
        .eq("team", teamId)
        .filter("is_bot", "neq", true)
        .gte("joined_formatted_ts", startTime)
        .lte("joined_formatted_ts", endTime),
    ]);
    // console.log("moderation", newUsers);
    if (
      "data" in atRisk &&
      "count" in moderation &&
      "count" in noreply &&
      "data" in newUsers
    ) {
      // console.log("atrisk", atRisk.results)
      setCommunityTasks([
        {
          name: `${noreply.count} unresponded messages`,
          link: "/messages",
          emoji: <MessageTwoTone />,
        },
        {
          name: `${moderation.count} in moderation queue`,
          link: "/moderation",
          emoji: <FlagTwoTone />,
        },
        {
          name: `${atRisk.data.length} at-risk members`,
          link: "/members",
          emoji: <FunnelPlotTwoTone />,
        },
        {
          name: `${newUsers.data.length} newly joined members`,
          link: "/members",
          emoji: <CrownTwoTone />,
        },
        {
          name: "Send DMs",
          link: "/messages",
          emoji: <MailTwoTone />,
        },
      ]);
    }

    return noreply;
  };

  const loadEngagement = async (startTime, endTime) => {
    setEngagementMetrics(engagementMetricsDefault);
    const params = {
      end_time: endTime,
      start_time: startTime,
      team_id: teamId,
    };

    const dayDiff = moment(endTime).diff(moment(startTime), "days");

    const previousParams = {
      end_time: moment(endTime)
        .subtract(dayDiff, "day")
        .format(defaultTimeFormat),
      start_time: moment(startTime)
        .subtract(dayDiff, "day")
        .format(defaultTimeFormat),
      team_id: teamId,
    };
    // using message type overall function that returns count of messages by admin vs not, hence adding them
    const [
      currentActive,
      previousActive,
      currentMessage,
      previousMessage,
      currentReactions,
      previousReactions,
    ] = await Promise.all([
      supabase.rpc("active_users_count", params),
      supabase.rpc("active_users_count", previousParams),
      supabase.rpc("message_type_overall", params),
      supabase.rpc("message_type_overall", previousParams),
      supabase.rpc("reactions_count", params),
      supabase.rpc("reactions_count", previousParams),
    ]);
    // console.log("engagement", currentReactions, dayDiff, currentActive, previousActive, currentMessage, previousMessage)

    let currentMessageNum = "-";
    if (currentMessage.data.length > 1) {
      currentMessageNum =
        currentMessage.data[0].num + currentMessage.data[1].num;
    } else if (currentMessage.data.length === 1) {
      currentMessageNum = currentMessage.data[0].num;
    }

    let previousMessageNum = "-";
    if (previousMessage.data?.length > 1) {
      previousMessageNum =
        previousMessage.data[0].num + previousMessage.data[1].num;
    } else if (previousMessage.data?.length === 1) {
      previousMessageNum = previousMessage?.data[0]?.num;
    }
    setEngagementMetrics({
      currentActive: currentActive.data[0]
        ? currentActive.data[0].total_count
        : "-",
      previousActive: previousActive.data[0]
        ? previousActive.data[0].total_count
        : "-",
      currentReactions: currentReactions.data[0]
        ? currentReactions.data[0].total_count
        : "-",
      previousReactions: previousReactions.data[0]
        ? previousReactions.data[0].total_count
        : "-",
      currentMessage: currentMessageNum,
      previousMessage: previousMessageNum,
      activePercent:
        currentActive.data[0] && previousActive.data[0]
          ? (
              ((currentActive.data[0].total_count -
                previousActive.data[0].total_count) /
                previousActive.data[0].total_count) *
              100
            ).toFixed(1)
          : "-",
      reactionsPercent:
        currentReactions.data[0]?.total_count &&
        previousReactions.data[0]?.total_count
          ? (
              ((currentReactions.data[0].total_count -
                previousReactions.data[0].total_count) /
                previousReactions.data[0].total_count) *
              100
            ).toFixed(1)
          : "-",
      messagePercent:
        currentMessage.data[0]?.total_count &&
        previousMessage.data[0]?.total_count
          ? (
              ((currentMessageNum - previousMessageNum) / previousMessageNum) *
              100
            ).toFixed(1)
          : "-",
      loading: false,
    });

    params.start_time = moment(endTime)
      .subtract(30, "day")
      .format(defaultTimeFormat);
    const { data } = await supabase.rpc("messages_count_week", params);
    if (data) {
      const newData = data.map((item, index) => {
        // console.log("sup", index,data.length )
        return {
          total_count: index == data.length - 1 ? null : item.total_count,
          week: moment(item.week).format("MM/DD/YY"),
          current: index >= data.length - 2 ? item.total_count : null,
          label: index == data.length - 1 ? "Ongoing" : null,
        };
      });
      setWeeklyMessageCount(newData);
    }
  };

  const loadMessageType = async (startTime, endTime) => {
    setLoadingConversation(true);
    // console.log("start times", startTime, endTime);
    const params = {
      start_time: startTime,
      end_time: endTime,
      team_id: teamId,
    };
    const { data, error } = await supabase.rpc("message_type_overall", params);

    if (error) console.error(error);
    if (data) {
      const formattedResult = data.map(function (val) {
        if (val.is_admin === "false") {
          val.name = "community";
        } else {
          val.name = "moderators";
        }
        return val;
      });
      setLoadingConversation(false);
      setMessageType(formattedResult);
    }
    return data;
  };

  const loadPowerUsers = async (startTime, endTime) => {
    setLoadingActiveMember(true);
    const params = {
      start_time: startTime,
      end_time: endTime,
      team_id: teamId,
    };
    const { data, error } = await supabase.rpc("power_users_overall", params);

    if (error) console.error(error);
    if (data) {
      setLoadingActiveMember(false);
      setPowerUsers(data);
    }
    return data;
  };

  const loadActiveChannels = async (startTime, endTime) => {
    setLoadingChannels(true);
    const params = {
      start_time: startTime,
      end_time: endTime,
      team_id: teamId,
    };
    const { data, error } = await supabase.rpc("active_channels", params);

    if (error) console.error(error);
    if (data) {
      setActiveChannels(data);
    }

    const inactive = await supabase.rpc("inactive_channels", params);
    if (inactive.data) {
      setInActiveChannels(inactive.data);
    }
    setLoadingChannels(false);
    return data;
  };

  const loadPageData = async (startTime, endTime) => {
    const onedayInMs = 1000 * 60 * 60 * 24;
    // Calculate the numbers days from startTime until now
    // Example if today is 20 and startTime is 15, then active_period_start = 5
    const startDays = Math.floor(
      (new Date().getTime() - new Date(startTime).getTime()) / onedayInMs
    );
    setLoading(true);
    const [excludeChannels] = await Promise.all([loadExcludedChannels()]);
    setExcludedChannels(excludeChannels);

    loadTasks(startTime, endTime, excludeChannels, {
      active_period_start: startDays * 3,
      inactive_period_start: startDays,
    });
    loadEngagement(startTime, endTime);
    loadMessageType(startTime, endTime);
    loadPowerUsers(startTime, endTime);
    loadActiveChannels(startTime, endTime);
    setLoading(false);
  };

  useEffect(() => {
    loadPageData(startTime, endTime);
    document.title = "Home | Dots";
  }, []);

  const changeDates = async (startTime, endTime) => {
    setLoading(true);
    setStartTime(moment(startTime).format(dateFormat));
    setEndTime(moment(endTime).format(dateFormat));
    await loadPageData(startTime, endTime);
    setLoading(false);
  };

  const [datePickerText, setDatePickerText] = useState("Past 7 days");
  const [isTimeModalVisible, setIsTimeModalVisible] = useState(false);

  function handleMenuClick(e) {
    window.analytics.track("Time changed");
    if (e.key == 1) {
    }
    // past 7 days
    else if (e.key == 2) {
      message.info("Loading..", 4);
      changeDates(
        moment().subtract(7, "day").format(defaultTimeFormat),
        moment().format(defaultTimeFormat)
      );
      setDatePickerText("Past 7 days");
    }
    // past 30 days
    else if (e.key == 3) {
      message.info("Loading..", 4);
      changeDates(
        moment().subtract(30, "day").format(defaultTimeFormat),
        moment().format(defaultTimeFormat)
      );
      setDatePickerText("Past 30 days");
    }
    // custom
    else if (e.key == 4) {
      setDatePickerText("Select range");
    }
  }
  // data changed

  const showTimeModal = () => {
    window.analytics.track("Custon time");
    setIsTimeModalVisible(true);
  };

  const handleCancel = () => {
    setDatePickerText(
      `${moment(startTime).format(dateFormat)} - ${moment(endTime).format(
        dateFormat
      )}`
    );
    setIsTimeModalVisible(false);
  };

  const dateChanged = async (date, dateString) => {
    console.log(
      "date changed picker",
      date[0].isValid(),
      dateString,
      date[0].format(defaultTimeFormat),
      date[1].format(defaultTimeFormat)
    );
    setLoading(true);
    setStartTime(date[0].format(dateFormat));
    setEndTime(date[1].format(dateFormat));
    await loadPageData(
      date[0].format(defaultTimeFormat),
      date[1].format(defaultTimeFormat)
    );
    setDatePickerText(
      `${moment(startTime).format(dateFormat)} - ${moment(endTime).format(
        dateFormat
      )}`
    );
    setLoading(false);
  };

  const showPopularModal = () => {
    window.analytics.track("View more messages clicked");
    setPopularModalVisible(true);
  };

  const hidePopularModal = () => {
    setPopularModalVisible(false);
  };

  const getChannelFilters = (posts) => {
    const filterValues = new Set();
    for (const post of posts) {
      filterValues.add(post.channelName);
    }
    const filters = [];
    for (const value of filterValues) {
      filters.push({ text: value, value });
    }
    return filters;
  };

  const popularMessagesColumns = [
    {
      title: "Message",
      dataIndex: "text",
      key: "text",
      render: (text, record) => {
        let image32 = "";
        let userName = "";
        if (record.slack_user) {
          image32 = record.slack_user.image_32;
          userName = record.slack_user.name;
        }
        return (
          <div>
            <Row>
              <Col span={2}>
                <Avatar src={image32} />
              </Col>
              <Col span={22}>
                <Row>
                  <span style={{ color: "grey", marginRight: "10px" }}>
                    {userName}
                  </span>
                  <span style={{ color: "grey", marginRight: "10px" }}>
                    | {record.posted}
                  </span>
                  <Tooltip title="Click to open in slack">
                    <a href={record.permalink} target="_blank" rel="noreferrer">
                      <img
                        alt="link"
                        width="12"
                        src="/external-link-alt-solid.svg"
                      />
                    </a>
                  </Tooltip>
                </Row>
                <Row>
                  <Emoji text={record.text} />
                </Row>
                <Row>
                  <span style={{ color: "grey", marginRight: "10px" }}>
                    {record.reaction_count} reactions | {record.reply_count}{" "}
                    replies{" "}
                  </span>
                </Row>
              </Col>
            </Row>
          </div>
        );
      },
      filters: [
        { text: "Admin", value: true },
        { text: "Non-admin", value: false },
      ],
      onFilter: (value, record) => record.userAdmin === value,
    },
    {
      title: "Channel",
      dataIndex: "channelName",
      filters: getChannelFilters(popularPosts),
      onFilter: (value, record) => record.channelName.indexOf(value) === 0,
      sorter: (a, b) => {
        if (a.channelName < b.channelName) {
          return -1;
        }
        if (a.channelName > b.channelName) {
          return 1;
        }
        return 0;
      },
      sortDirections: ["descend", "ascend"],
      width: "20%",
    },
  ];

  const menu = (
    <Menu onClick={handleMenuClick}>
      {/* <Menu.Item key="1">
        Yesterday
      </Menu.Item> */}
      <Menu.Item key="2">Past 7 days</Menu.Item>
      <Menu.Item key="3">Past 30 days</Menu.Item>
      <Menu.Item key="4" onClick={showTimeModal}>
        Custom
      </Menu.Item>
    </Menu>
  );

  function copyElementToClipboard(element) {
    window.getSelection().removeAllRanges();
    const range = document.createRange();
    range.selectNode(
      typeof element === "string" ? document.getElementById(element) : element
    );
    window.getSelection().addRange(range);
    document.execCommand("copy");
    window.getSelection().removeAllRanges();
  }

  const onSelectChange = async (selectedRowKeys, selectedRows) => {
    // console.log('selectedRowKeys changed: ', selectedRowKeys, selectedRows);
    setSelectedMessages(selectedRowKeys.slice(0, 100));
    // let messageText = ''
    // selectedRows.forEach((item, index)=>{
    //   messageText +=
    //                 '\n' + '[' + item.text + ']('+ item.permalink + ')'
    //                 +'\ #### \ ' + item.reply_count + ' replies & '+ item.reaction_count + ' reactions' + '<br/>'
    // })
    const messagesDiv = document.getElementById("hidden-messages");
    messagesDiv.innerHTML = "";
    await selectedRows.forEach((item) => {
      const li = document.createElement("li");
      li.innerHTML =
        `<p> <strong> ${
          item.slack_user ? item.slack_user.name : null
        } </strong> in <i>${item.channelName}</i></p>` +
        `<p><a href="${item.permalink}">${item.text}</a></p>` +
        `<p>(${item.reply_count} ${
          item.reply_count > 1 ? "replies" : "reply"
        } | ${item.reply_count} ${
          item.reply_count > 1 ? "reactions" : "reaction"
        })</p>`;
      messagesDiv.appendChild(li);
    });
  };

  const rowSelection = {
    selectedRowKeys: selectedMessages,
    onChange: onSelectChange,
  };

  const hasMessagesSelected = selectedMessages.length > 0;

  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: "Copied to clipboard!",
    });
  };

  const copyMessages = () => {
    // TODO: this is hacky
    document.getElementById("hidden-messages").style.display = "inline";
    copyElementToClipboard("hidden-messages");
    document.getElementById("hidden-messages").style.display = "none";
    openNotificationWithIcon("success");
  };

  const channelToggle = (e) => {
    // console.log('radio4 checked', e.target.value);
    setActiveChannelRadio(e.target.value);
  };

  return (
    <div>
      <Spin spinning={loading}>
        <Row style={{ paddingBottom: 40 }}>
          <Col span={8} />
          <Col span={8} offset={8} style={{ textAlign: "end" }}>
            <Space>
              <Dropdown className="joyride-date" overlay={menu}>
                <Button>
                  {datePickerText} <DownOutlined />
                </Button>
              </Dropdown>
              <Modal
                width={400}
                title="Select date range "
                style={{ top: 40, right: 10 }}
                visible={isTimeModalVisible}
                onCancel={handleCancel}
                footer={[
                  <Button key="submit" onClick={handleCancel}>
                    Ok
                  </Button>,
                ]}
              >
                <RangePicker
                  // defaultValue={[ moment(startTime, dateFormat) , moment(endTime, dateFormat)]}
                  defaultValue={[
                    moment(startTime, dateFormat),
                    moment(endTime, dateFormat),
                  ]}
                  format={dateFormat}
                  disabledDate={disabledDate}
                  onChange={dateChanged}
                />
              </Modal>
            </Space>
          </Col>
        </Row>

        <Row justify="spaced-around" gutter={[48, 48]}>
          <Col lg={12} md={24}>
            <Card
              style={{ marginBottom: 40 }}
              title="Tasks"
              bordered={false}
              extra={[]}
              className="card-tasks"
            >
              <List
                dataSource={communityTasks}
                renderItem={(item) => (
                  <List.Item>
                    <List.Item.Meta
                      avatar={item.emoji}
                      title={
                        <a href={item.link} style={{ fontWeight: 400 }}>
                          {item.name}
                        </a>
                      }
                      // description={<p>{item.reaction_count} reactions</p>}
                    />
                    <div>
                      <a href={item.link}>View</a>
                    </div>
                  </List.Item>
                )}
              />
            </Card>

            <Card
              style={{ marginBottom: 40 }}
              title="Most active members"
              bordered={false}
              extra={[]}
            >
              <Spin spinning={loadingActiveMember}>
                <List
                  dataSource={powerUsers}
                  renderItem={(item) => <UserListItem user={item} />}
                />
              </Spin>
            </Card>

            <Card
              style={{ marginBottom: 40 }}
              title="# conversations by user type"
              bordered={false}
              extra={[]}
            >
              <Spin spinning={loadingConversation}>
                <div style={{ width: "100%" }}>
                  <RenderPieChart
                    data={messageType}
                    dataline="avg_reply_count"
                    dataline_name="Avg reply count"
                  />
                </div>
              </Spin>
            </Card>
          </Col>
          <Col lg={12} md={24}>
            <div style={{ paddingBottom: 35 }}>
              <EngagementCard url="/insights" teamId={teamId} span={12} />
            </div>

            <TopPosts
              platform="slack"
              excludeChannels={excludedChannels}
              // startTime={startTime}
              // endTime={endTime}
            />

            <Card
              style={{ marginBottom: 40 }}
              title="Channel activity"
              bordered={false}
              extra={
                <Radio.Group
                  buttonStyle="solid"
                  size="small"
                  defaultValue
                  value={activeChannelRadio}
                  onChange={channelToggle}
                >
                  <Radio.Button value>Active</Radio.Button>
                  <Radio.Button value={false}>Inactive</Radio.Button>
                </Radio.Group>
              }
            >
              <Spin spinning={loadingChannels}>
                {activeChannelRadio
                  ? ""
                  : "Channels with no messages (in selected time period)"}
                <List
                  className="popular-channels"
                  dataSource={
                    activeChannelRadio ? activeChannels : inActiveChannels
                  }
                  renderItem={(item) => (
                    <List.Item>
                      <List.Item.Meta
                        title={
                          <a
                            // href={`/channel/${item.channel_id}`}
                            onKeyDown={() =>
                              navigate(`/channel/${item.channel_id}`)
                            }
                            onClick={() =>
                              navigate(`/channel/${item.channel_id}`)
                            }
                            role="button"
                            tabIndex={0}
                          >
                            #{item.channel_name}
                          </a>
                        }
                      />
                      {activeChannelRadio ? (
                        <div>
                          {item.num} {item.num > 1 ? "messages" : "message"}
                        </div>
                      ) : (
                        ""
                      )}
                    </List.Item>
                  )}
                />
              </Spin>
            </Card>
          </Col>
        </Row>
      </Spin>
    </div>
  );
};

export default Overall;
